import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useHistory, withRouter } from 'react-router';
import classNames from 'classnames';
import './index.scss';

import { currentUserIsDepotRole, isRTL } from '../../../services/userModel';
import User from '../../../services/user';
import {
    CUSTOMER_SERVICE_MODEL,
    getRatingList,
    GLOBAL_FILTER_TYPE,
    SECTION_MODEL_FACTORY_TYPE,
    SHIFTS_MODEL,
    TYPE_MENU,
} from '../../../utils/enums';
import { createAction } from '../../../utils/sagaHelper';
import { getHistoryLocationParams } from '../../../utils/routesHelper';
import { settingsRowHeightDefault } from '../../../utils/constants';
import {
    actionSaveSectionItemRowHeightDefault,
} from '../../../store/reducers/sectionsWrapperData/sectionsWrapperData-actions';
import { SECTION_MODEL_GET } from '../../../store/reducers/routing/routing-actions';

import MenuService from '../../../services/menu';
import SectionWrapperCustomTable from '../SectionWrapper/SectionWrapperCustomTable';
import moment from 'moment';
import { buildFilterModel, buildSortModel } from '../../../utils/tableFiltersHelpers';
import { CUSTOM_TABLE_CONFIG_SET_FILTERS, CUSTOM_TABLE_CONFIG_SET_PAGINATION } from '../../../store/reducers/order/order-actions';
import { withTranslation } from 'react-i18next';
import GlobalFilterDataService from '../../../services/globalFilterDataService';
import { SummaryCustomerConsumerOrdersFilter } from '../SummaryOrderFilter/SummaryOrderFilter';
import CustomersData from '../CustomersData';
import AnalyticsPeriodControl from '../AnalyticsPeriodControl';
import i18n from '../../../i18n';
import { Tooltip } from 'antd';

const EMPTY_FILTERS = {};

class OrdersPageWrapper extends Component {
    constructor(props) {
        super(props);

        this.state = {
            item: null,
            filter: { periodFilter: {} },
        };

        this.menu = this.getCurrentMenu() || [];

        props.saveSectionItemRowHeightDefault(settingsRowHeightDefault);
        this.handleOnAddItem = this.handleOnAddItem.bind(this);
    }

    getCurrentMenu() {
        return MenuService.instance.getMenu(TYPE_MENU.customerService);
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { typeSectionModel, currentModelType, items, language } = this.props;
        const { item, isPopupOpen, pinnedPopup, popupItem } = this.state;

        if (language !== nextProps.language) {
            this.menu = this.getCurrentMenu();
        }

        if(this.props.item.ConsumerId !== nextProps.item.ConsumerId) {
            this.updateUserId(nextProps.item.ConsumerId);
        }

        return (
            currentModelType !== nextProps.currentModelType ||
            typeSectionModel !== nextProps.typeSectionModel ||
            language !== nextProps.language ||
            items !== nextProps.items ||
            item !== nextState.item ||
            isPopupOpen !== nextState.isPopupOpen ||
            pinnedPopup !== nextState.pinnedPopup ||
            popupItem !== nextState.popupItem ||
            this.state.searchValue !== nextState.searchValue ||
            this.props.item.ConsumerId !== nextProps.item.ConsumerId
        );
    }

    componentWillUnmount() {
        const { typeSectionModel, itemAction, currentModelType } = this.props;

        if (typeSectionModel && typeSectionModel.actionOnUnmount) {
            itemAction(typeSectionModel.actionOnUnmount, currentModelType);
        }
    }

    componentDidMount() {
        const { itemAction, currentModelType, typeSectionModel, customTableFilter, updateFilterTable } = this.props;

        if (currentModelType && typeSectionModel) {
            if (typeSectionModel.actionLoad) {
                itemAction(typeSectionModel.actionLoad, currentModelType);
            }

            this.forceUpdate();
        }

        if (typeSectionModel.customTableConfig) {
            const filter = typeSectionModel.customTableConfig.filterType ? GlobalFilterDataService.instance.getFilter(typeSectionModel.customTableConfig.filterType) : {};
            const customFilter = { ...typeSectionModel?.customTableConfig?.defaultFilters };
            if (this.props.item.ConsumerId) {
                customFilter.customerId = {
                    operator: "is",
                    type: "string",
                    value: this.props.item.ConsumerId,
                    value2: null,
                };
            }

            const savedFilters = customTableFilter?.[typeSectionModel?.customTableConfig?.key] || {}

            updateFilterTable({ data: { ...savedFilters, ...customFilter }, key: typeSectionModel?.customTableConfig?.key });

            this.updateFilter(typeSectionModel.customTableConfig?.mainDateKey ? filter : {}, { ...savedFilters, ...customFilter });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { itemAction, currentModelType, typeSectionModel } = this.props;

        if (currentModelType !== prevProps.currentModelType) {
            if (typeSectionModel.actionLoad) {
                itemAction(typeSectionModel.actionLoad, currentModelType);
            }
        }

        this.updateItem();
    }

    updateItem = () => {
        
    };


    handleOnAddItem = () => {
        const { history, typeSectionModel, currentModelType } = this.props;
        history.push(
            typeSectionModel.urlNewItem
                ? typeSectionModel.urlNewItem
                : `${currentModelType}/new`
        );
    };

    handleOnBack = isStay => {
        const {
            itemAction,
            typeSectionModel,
            currentModelType,
            sectionModels,
            history,
            location
        } = this.props;
        const { search } = location;

        return new Promise(resolve => {
            resolve();

            if (isStay) {
                if (typeSectionModel.actionLoad) {
                    itemAction(typeSectionModel.actionLoad, currentModelType);
                }
            } else {
                const { parentUrl, typeModel } = typeSectionModel;
                if (parentUrl || search.includes("parentId")) {
                    if (
                        Object.values(CUSTOMER_SERVICE_MODEL).includes(
                            location.pathname
                        )
                    ) {
                        // copy pasta from OrderingSection.jsx for compability
                        const { search } = location;

                        if (
                            (parentUrl &&
                                parentUrl !==
                                CUSTOMER_SERVICE_MODEL.orderingMenuEdit) ||
                            search.includes("parentId")
                        ) {
                            const { parentId, subId, id } = getHistoryLocationParams(search);

                            if (
                                typeModel ===
                                CUSTOMER_SERVICE_MODEL.reviewProductExtra
                            ) {
                                history.push(
                                    parentUrl + `?parentId=${parentId}&id=${id}&subId=${subId}`
                                );
                            } else {
                                const url = sectionModels[parentUrl].id
                                    ? parentUrl + `?id=${sectionModels[parentUrl].id}`
                                    : parentId
                                        ? parentUrl + `?id=${parentId}`
                                        : parentUrl;
                                history.push(
                                    subId ? parentUrl + search.split("&subId")[0] : url
                                );
                            }
                        } else {
                            history.push(parentUrl + search);
                        }
                    } else {
                        const { parentId } = getHistoryLocationParams(search);
                        const url = sectionModels[parentUrl].id
                            ? parentUrl + `?id=${sectionModels[parentUrl].id}`
                            : parentId
                                ? parentUrl + `?id=${parentId}`
                                : parentUrl;
                        history.push(url);
                    }
                } else {
                    history.push(CUSTOMER_SERVICE_MODEL.customers);
                }
            }
        });
    };

    handleOnFilterOrdersClose = () => {
        const { itemAction, currentModelType, typeSectionModel } = this.props;

        switch (currentModelType) {
            case SHIFTS_MODEL.history:
            case SHIFTS_MODEL.providers:
                itemAction(typeSectionModel.actionLoad);
                break;
            case SHIFTS_MODEL.currentShiftUsers:
                itemAction(typeSectionModel.actionLoad);
                break;
            default:
                break;
        }
    };

    handleOnLayout = (link, editItem) => {
        const { getSectionModel, itemAction } = this.props;

        if (link) {
            getSectionModel({
                link,
                editItem,
                type: SECTION_MODEL_FACTORY_TYPE.marketplaceSettings
            }).then(model => {
                if (model && model.model && model.model.actionLoad) {
                    itemAction(model.model.actionLoad);
                }
            });
        }
    };

    getHistoryItems = (filters, tableFilter, page, changePagination, searchValue) => {
        const {
            orders,
            historyOrders,
            loadHistoryOrders,
            typeSectionModel,
        } = this.props;
        const sectionModel = typeSectionModel;
        if (sectionModel && sectionModel.filterOptions && sectionModel.customTableConfig.loadDataAction) {
            loadHistoryOrders(sectionModel.customTableConfig.loadDataAction, {
                ordersFilterModel: filters || this.state.filter,
                activeOrders: orders,
                searchValue: searchValue ?? this.state.searchValue,
                historyOrders,
                tableFilter: tableFilter?.filters,
                tableSort: tableFilter?.sort,
                changePagination,
                page,
                key: typeSectionModel?.customTableConfig?.key,
            });
        }
    };

    updateFilter = (data, tableFilter, searchValue) => {
        const { filter } = this.state;
        const { setPageData, updateFilterTable, customTablePagination, typeSectionModel } = this.props;
        const sectionModel = typeSectionModel;
        let dateEnd = data.end ? new Date(data.end) : null;
        let dateStart = data.start ? new Date(data.start) : null;

        const tagblePagination = customTablePagination?.[sectionModel.filterTableKey] || {};
        if (dateStart && !dateEnd) {
            dateEnd = moment(dateStart).add(1, 'month');
        }
        if (dateEnd && !dateStart) {
            dateStart = moment(dateEnd).subtract(1, 'month');
        }
        if (moment(data.end).isSame(filter.end) && !moment(data.start).isSame(filter.start)) {
            if (Math.abs(moment(data.start).diff(data.end, 'month')) <= 1) {
                dateEnd = new Date(data.end);
            } else {
                dateEnd = moment(dateStart).add(1, 'month');
            }
        }

        if (!moment(data.end).isSame(filter.end) && moment(data.start).isSame(filter.start)) {
            if (Math.abs(moment(data.end).diff(data.start, 'month')) <= 1) {
                dateStart = new Date(data.start);
            } else {
                dateStart = moment(dateEnd).subtract(1, 'month');
            }
        }

        dateStart = new Date(dateStart);
        dateEnd = new Date(dateEnd);

        if (data.end || data.start) {
            const customDateFilter = {
                operator: 'between',
                type: 'date',
                value: dateStart,
                value2: dateEnd,
                sort: tableFilter?.[typeSectionModel.customTableConfig?.mainDateKey]?.sort || 0,
            };
            tableFilter[typeSectionModel.customTableConfig?.mainDateKey] = customDateFilter;
            updateFilterTable({ data: { ...tableFilter, [typeSectionModel.customTableConfig?.mainDateKey]: customDateFilter }, key: typeSectionModel?.customTableConfig?.key });
        }

        sectionModel.setFilterOption('date', 'selected', dateStart);
        sectionModel.setFilterOption('dateEnd', 'selected', dateEnd);

        const newFilter = { ...this.state.filter, ...data, start: dateStart, end: dateEnd };
        if (sectionModel.customTableConfig.filterType) {
            GlobalFilterDataService.instance.setFilter(sectionModel.customTableConfig.filterType, newFilter);
        }
        this.setState({ filter: newFilter });

        const filterModel = tableFilter && buildFilterModel(tableFilter, sectionModel.customTableConfig?.factoryMap);
        const sortModel = tableFilter && buildSortModel(tableFilter, sectionModel.customTableConfig?.factoryMap);
        setPageData({ data: { page: 0 }, key: typeSectionModel?.customTableConfig?.key });
        this.getHistoryItems(newFilter, { filters: filterModel, sort: sortModel }, { pageSize: tagblePagination?.pageSize }, false, searchValue);
    }

    onRefreshData = (filters, page) => {
        const { typeSectionModel } = this.props;
        const { filter, searchValue } = this.state;
        const sectionModel = typeSectionModel;

        let dateStart = filters?.[typeSectionModel.customTableConfig?.mainDateKey]?.value ? new Date(filters?.[typeSectionModel.customTableConfig?.mainDateKey]?.value) : null;
        let dateEnd = filters?.[typeSectionModel.customTableConfig?.mainDateKey]?.value2 ? new Date(filters?.[typeSectionModel.customTableConfig?.mainDateKey]?.value2) : null;

        if (filters[typeSectionModel.customTableConfig?.mainDateKey]) {
            if (dateStart && !dateEnd) {
                dateEnd = moment(dateStart).add(1, 'month');
            }
            if (dateEnd && !dateStart) {
                dateStart = moment(dateEnd).subtract(1, 'month');
            }
            if (moment(filters?.[typeSectionModel.customTableConfig?.mainDateKey]?.value2).isSame(filter.end) && !moment(filters?.[typeSectionModel.customTableConfig?.mainDateKey]?.value).isSame(filter.start)) {
                if (Math.abs(moment(filters?.[typeSectionModel.customTableConfig?.mainDateKey]?.value).diff(filters?.[typeSectionModel.customTableConfig?.mainDateKey]?.value2, 'month')) <= 1) {
                    dateEnd = new Date(filters?.[typeSectionModel.customTableConfig?.mainDateKey]?.value2);
                } else {
                    dateEnd = moment(dateStart).add(1, 'month');
                }
            }

            if (!moment(filters?.[typeSectionModel.customTableConfig?.mainDateKey]?.value2).isSame(filter.end) && moment(filters?.[typeSectionModel.customTableConfig?.mainDateKey]?.value).isSame(filter.start)) {
                if (Math.abs(moment(filters?.[typeSectionModel.customTableConfig?.mainDateKey]?.value2).diff(filters?.[typeSectionModel.customTableConfig?.mainDateKey]?.value, 'month')) <= 1) {
                    dateStart = new Date(filters?.[typeSectionModel.customTableConfig?.mainDateKey]?.value);
                } else {
                    dateStart = moment(dateEnd).subtract(1, 'month');
                }
            }

            if (!moment(filters?.[typeSectionModel.customTableConfig?.mainDateKey]?.value2).isSame(filter.end) && !moment(filters?.[typeSectionModel.customTableConfig?.mainDateKey]?.value).isSame(filter.start)) {
                dateStart = new Date(filters?.[typeSectionModel.customTableConfig?.mainDateKey]?.value);
                dateEnd = moment(filters?.[typeSectionModel.customTableConfig?.mainDateKey]?.value).add(1, 'month');
            }

            dateStart = new Date(dateStart);
            dateEnd = new Date(dateEnd);
            filters[typeSectionModel.customTableConfig?.mainDateKey].value = dateStart;
            filters[typeSectionModel.customTableConfig?.mainDateKey].value2 = dateEnd;
        }

        sectionModel.setFilterOption('date', 'selected', filters[typeSectionModel.customTableConfig?.mainDateKey] ? dateStart : null);
        sectionModel.setFilterOption('dateEnd', 'selected', filters[typeSectionModel.customTableConfig?.mainDateKey] ? dateEnd : null);
        const newFilter = { periodFilter: {}, start: filters[typeSectionModel.customTableConfig?.mainDateKey] ? dateStart : null, end: filters[typeSectionModel.customTableConfig?.mainDateKey] ? dateEnd : null };
        if (newFilter.start === this.state.filter.start && newFilter.end === this.state.filter.end) {
            newFilter.periodFilter = this.state.filter.periodFilter;
        }
        if (sectionModel.customTableConfig.filterType) {
            GlobalFilterDataService.instance.setFilter(sectionModel.customTableConfig.filterType, newFilter);
        }
        this.setState({ filter: newFilter });
        let pageOrSortChanged = false;
        if (page) {
            pageOrSortChanged = page?.pageOrSortChanged || false;
            delete page.pageOrSortChanged;
        }
        this.getHistoryItems(null, { filters: buildFilterModel(filters, sectionModel.customTableConfig?.factoryMap), sort: buildSortModel(filters, sectionModel.customTableConfig?.factoryMap) }, page, pageOrSortChanged, searchValue);
    }

    updateUserId = (newUser) => {
        const { customTableFilter, typeSectionModel, setPageData, updateFilterTable } = this.props;
        const filter = {...customTableFilter?.[typeSectionModel?.customTableConfig?.key], customerId: {
            operator: "is",
            type: "string",
            value: newUser,
            value2: null,
        }};
        const buildedFilter = buildFilterModel(filter, typeSectionModel.customTableConfig?.factoryMap);
        updateFilterTable({ data: { ...filter }, key: typeSectionModel?.customTableConfig?.key });
        setPageData({ data: { page: 0 }, key: typeSectionModel?.customTableConfig?.key });

        this.getHistoryItems(null, { filters: buildedFilter, sort: buildSortModel(customTableFilter?.[typeSectionModel?.customTableConfig?.key], typeSectionModel.customTableConfig?.factoryMap) }, 0, false, this.state.searchValue);
    }

    setSearchValue = (value) => {
        const { customTableFilter, typeSectionModel } = this.props;
        this.setState({ searchValue: value });
        this.getHistoryItems(null, { filters: buildFilterModel(customTableFilter?.[typeSectionModel?.customTableConfig?.key], typeSectionModel.customTableConfig?.factoryMap), sort: buildSortModel(customTableFilter?.[typeSectionModel?.customTableConfig?.key], typeSectionModel.customTableConfig?.factoryMap) }, 0, false, value);
    }

    getData = () => {
        const { customTablePagination, typeSectionModel } = this.props;
        return customTablePagination?.[typeSectionModel?.customTableConfig?.key]?.orders?.Page || [];
    }

    getFilters = () => {
        const { typeSectionModel, customTableFilter } = this.props;
        return customTableFilter?.[typeSectionModel?.customTableConfig?.key] || EMPTY_FILTERS;
    }

    getPagination = () => {
        const { customTablePagination, typeSectionModel } = this.props;
        return customTablePagination?.[typeSectionModel?.customTableConfig?.key] || {};
    }

    onSelectRow = (item) => {
        const { typeSectionModel } = this.props;
        if (typeSectionModel?.customTableConfig?.popupComponent) {
            this.setState({ popupItem: item, isPopupOpen: true });
        }
    }

    onCloseItem = () => {
        this.setState({ popupItem: null, isPopupOpen: false, pinnedPopup: false });
    }

    handleOnPinToggle = () => {
        this.setState({ pinnedPopup: !this.state.pinnedPopup })
    }

    render() {
        const { typeSectionModel, location, t, setPageData, updateFilterTable, item, onClickBackButton, showBackButton } = this.props;
        const { filter, isPopupOpen, popupItem, pinnedPopup } = this.state;

        const isNewTableMode = [CUSTOMER_SERVICE_MODEL.order, CUSTOMER_SERVICE_MODEL.reviews, CUSTOMER_SERVICE_MODEL.customers, CUSTOMER_SERVICE_MODEL.unfinishedCart].includes(location.pathname);

        return (
            <div id="settingspage" className={classNames("settingsContainer customerservice ordersPageWrapper", typeSectionModel?.customSettings)}>
                <div className={classNames("centerSide", { rtl: isRTL(), pinnedPopup })}>
                    <CustomersData customerId={item.ConsumerId} onClickBackButton={onClickBackButton} showBackButton={showBackButton} closeButtonInChild={false} />
                    <div className='ordersPlaceholder'>{t('orders.ORDERS_INFO_LABLE')}</div>
                    {isNewTableMode && typeSectionModel && (
                        <SectionWrapperCustomTable
                            reportComponent={typeSectionModel?.customTableConfig?.reportComponent}
                            addComponent={typeSectionModel?.customTableConfig?.addComponent}
                            onSelectRow={this.onSelectRow}
                            summaryComponent={typeSectionModel?.customTableConfig?.summaryComponent}
                            customTableConfig={typeSectionModel?.customTableConfig}
                            searchValue={this.state.searchValue}
                            setSearchValue={this.setSearchValue}
                            onRefreshData={this.onRefreshData}
                            t={t}
                            sectionModel={typeSectionModel}
                            items={this.getData()}
                            onChangeData={(tableData => this.setState({ tableData }))}
                            filter={filter}
                            onSetFilter={this.updateFilter}
                            onFilterItemsClose={this.handleOnFilterOrdersClose}
                            handleOnSaveReport={() => { }}
                            hideSectionItemTitle
                            filters={this.getFilters()}
                            periodControl={
                                <AnalyticsPeriodControl filter={filter} onSetFilter={(value) => this.updateFilter(value, this.getFilters())} t={t} />
                            }
                            pagination={this.getPagination()}
                            onSetTablePagination={data => setPageData({ key: typeSectionModel?.customTableConfig?.key, data })}
                            onSetTableFilter={data => updateFilterTable({ key: typeSectionModel?.customTableConfig?.key, data })}
                            keyForDate={typeSectionModel.customTableConfig?.mainDateKey}
                        />
                    )}

                    <div className={classNames('customTablePopupContent', { isPopupOpen, pinnedPopup })}>
                        {isPopupOpen && typeSectionModel?.customTableConfig?.popupComponent({
                            item: popupItem,
                            customTableConfigKey: typeSectionModel?.customTableConfig?.key,
                            showBackButton: typeSectionModel?.customTableConfig?.hideDefaultCloseIcon,
                            onClickBackButton: this.onCloseItem,
                            closeButtonInChild: false,
                            closeIcon: false,
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

const ReviewItemCustomer = ({ value }) => {
    const history = useHistory();

    const handleOnCustomerClick = () => {
        if (value.customer_id && !currentUserIsDepotRole()) {
            history.push(`${CUSTOMER_SERVICE_MODEL.customers}?userId=${value.customer_id}`);
        }
    }

    return (<div className="reviewClickableItem" onClick={handleOnCustomerClick}>
        {value.customer_name}
    </div>);
}

const renderTextComponent = (text, trimTo) => {
    if (!text) return "";
    const shortText = text.length > (trimTo || 20) ? `${text.slice(0, (trimTo || 20))?.trim()}...` : text;
    return (
        <Tooltip styles={{ body: { textAlign: i18n.language === "he" ? "right" : "left" } }} title={text}>
            <span >{shortText}</span>
        </Tooltip>
    );
}

const mapStateToProps = state => {
    const sectionModel = state.sectionModel.sectionModels[CUSTOMER_SERVICE_MODEL.order].model;
    return {
        items:
            state.sectionModel.sectionModels[CUSTOMER_SERVICE_MODEL.order]
                .model &&
            state.sectionModel.sectionModels[
                CUSTOMER_SERVICE_MODEL.order
            ].model.mappingLambda(
                state,
                state.sectionModel.sectionModels[CUSTOMER_SERVICE_MODEL.order].id
            ),
        sectionModels: state.sectionModel.sectionModels,
        typeSectionModel: {
            ...sectionModel,
            columns: sectionModel.columns.map(column => column).concat(
                {
                    accessor: 'deliveryRating',
                    title: i18n.t('reviews.REVIEW_FILTER_RATE_DELIVERY'),
                    width: 200,
                    search: true,
                    canHideColumn: true,
                    component: (amount, item) => item.delivery_rating ? `${item.delivery_rating} ⭐` : '',
                    type: 'lookup',
                    lookupOptions: getRatingList,
                },
                {
                    accessor: 'rating',
                    title: i18n.t('reviews.REVIEW_FILTER_RATE_PRODUCT'),
                    width: 200,
                    search: true,
                    canHideColumn: true,
                    component: (amount, item) => item.rating ? `${item.rating} ⭐` : '',
                    type: 'lookup',
                    lookupOptions: getRatingList,
                },
                {
                    accessor: 'userName',
                    title: i18n.t('reviews.REVIEW_USER_NAME'),
                    width: 200,
                    canHideColumn: true,
                    component: (amount, item) => <ReviewItemCustomer value={item} />,
                    type: 'number',
                },
                {
                    accessor: 'review',
                    title: i18n.t('reviews.REVIEW_DELIVERY_RATING_FEEDBACK'),
                    width: 200,
                    canHideColumn: true,
                    component: (amount, item) => renderTextComponent(item.review),
                    type: 'number',
                },
            ),
            typeModel: CUSTOMER_SERVICE_MODEL.customerOrders,
            customTableConfig: {
                ...sectionModel.customTableConfig,
                key: 'customTableUserOrders',
                summaryComponent: SummaryCustomerConsumerOrdersFilter,
                mainDateKey: '',
                hideDatePredefinedValue: true,
                defaultFilters: null,
                filterType: GLOBAL_FILTER_TYPE.orderByCustomer,
                hideDefaultCloseIcon: true,
                closeButtonInChild: false,
                pinnablePopup: false,
            },
        },
        typeSectionModelId:
            state.sectionModel.sectionModels[CUSTOMER_SERVICE_MODEL.order].id,
        currentModelType: CUSTOMER_SERVICE_MODEL.order || null,
        language:
            User.instance.getCurrentUserInfo() &&
            User.instance.getCurrentUserInfo().configuration.language,
        customTableFilter: state.order.data.customTableConfigFilters,
        customTablePagination: state.order.data.customTableConfigPagination,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getSectionModel: data => dispatch(createAction(SECTION_MODEL_GET, data)),
        itemAction: (action, data) => dispatch(createAction(action, data)),
        saveSectionItemRowHeightDefault: data =>
            dispatch(actionSaveSectionItemRowHeightDefault(data)),
        setPageData: (data) => dispatch(createAction(CUSTOM_TABLE_CONFIG_SET_PAGINATION, data)),
        updateFilterTable: (data) => dispatch(createAction(CUSTOM_TABLE_CONFIG_SET_FILTERS, data)),
        loadHistoryOrders: (action, data) => dispatch(createAction(action, data)),
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(withTranslation()(OrdersPageWrapper))
);